import { selectTab } from "@/state/functions";
import { actions, RootState } from "@/state/reducer";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dataWriter } from "@/functions/data";
import { predict } from "@/functions/checker/predict";
import { getTextModerationResult } from "@/utils";
import { toast } from "sonner";
import { minLength } from "@/utils/config";

const textThemes = [
  "кролики",
  "скворцы",
  "шляпы",
  "трубы",
  "шишки",
  "динозавры",
  "перчатки",
  "голуби",
  "рубашки",
  "вороны",
  "фонари",
  "часы",
  "карандаши",
  "чемоданы",
  "облака",
  "корабли",
  "пуговицы",
  "зеркала",
  "ключи",
  "яблоки",
  "ботинки",
  "мосты",
  "книги",
  "свечи",
  "лестницы",
  "письма",
  "паруса",
  "чашки",
  "картины",
  "звёзды"
];

const TestStepTwo  = () => {
   const State = useSelector((state: RootState) => state);
   const dispatch = useDispatch();
   const text = State.text
   const [theme, setTheme] = useState<string>("");
   
   useEffect(() => {
      setTheme(textThemes[Math.floor(Math.random() * textThemes.length)]);
   }, [])

   const writeText = (event) => {
      const prevText = State.text;
      const text = String(event.target.value);
      const textD = text.length - prevText.length
      if (textD === 1 || textD === -1) {
         dispatch(actions.writtenText(text));
         // добавление — записываем добавленный символ,
         // удаление — записываем "Backspace" (важно для восстановления текста
         // и для признаков правок при анализе поведения)
         if (textD === 1) {
            dataWriter.writeKeyboardData(text[text.length - 1]);
         } else {
            dataWriter.writeKeyboardData("Backspace");
         }
      }
   }

   const finishStep = () => {
      const moderation = getTextModerationResult(text);
      if (moderation.error) {
         toast(moderation.error);
         dispatch(actions.writtenText(""));
         return;
      }
      selectTab("step3")
   }
   
    return(
    <div className="page greeting gridCenter w100">
       <div className="inner columnCenter gap24">
          <h1>{`Шаг2: Напишите текст по теме ${theme}, 500 знаков. Уникальный, вставка запрещена`}</h1>
          <textarea className="myTextEntry" rows={20} value={text} onChange={writeText} />
          <div className="textCounter">
              {`${text.length} / ${minLength}`}
          </div>
          <div className="btn mainBtn" onClick={finishStep}>
             Перейти на этап 3
          </div>  
          <div className="btn mainBtn" onClick={selectTab.bind(this, "")}>
             Начать заново
          </div>
       </div>
    </div>)
}

export default TestStepTwo;